import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { PlanLimitsService } from 'src/plan-limits/plan-limits.service';
import { PrismaModule } from 'src/prisma/prisma.module';
import { QueuesModule } from 'src/queues/queues.module';
import { SuscripcionesService } from 'src/suscripciones/suscripciones.service';
import { AiConfigModule } from 'src/ai-dashboard/ai-config/ai-config.module';
import { winstonConfig } from '../common/logger/winston.config';
import { ComisionesController } from './comisiones.controller';
import { ComisionesService } from './comisiones.service';
import { EmpresasController } from './empresas.controller';
import { EmpresasService } from './empresas.service';
import { JerarquiaEmpresasService } from './jerarquia-empresas.service';
import { RegistroEmpresaService } from './registro-empresa.service';

@Module({
  imports: [PrismaModule, QueuesModule, AuditModule, AiConfigModule],
  controllers: [EmpresasController, ComisionesController],
  providers: [EmpresasService, SuscripcionesService, JerarquiaEmpresasService, ComisionesService, PlanLimitsService, RegistroEmpresaService],
  exports: [EmpresasService, JerarquiaEmpresasService, ComisionesService, RegistroEmpresaService],
})
export class EmpresasModule {}
